// extracted by mini-css-extract-plugin
module.exports = {"header":"_5D2WGoof","header__icon":"_5Duy3U4s","header__title-wrapper":"_5D1UuNnu","header__category":"_5D1W0UIu","header__title":"_5D1sOsUu"};